import React from "react"
import { StyleProp, TextStyle, View, ViewStyle, Linking, TouchableOpacity } from "react-native"
import { observer } from "mobx-react-lite"
import { flatten } from "ramda"

import { color, typography, spacing } from "@app/theme"
import { Text } from "@app/components"

const CONTAINER: ViewStyle = {
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: color.palette.white,
  paddingTop: 32,
  paddingBottom: 32,
  paddingLeft: 16,
  paddingRight: 16
}

const TITLE: TextStyle = {
  fontFamily: typography.primaryBold,
  fontSize: 18,
  fontWeight: "bold",
  color: color.palette.pink5,
  marginBottom: 12
}

const LINKS_CONTAINER: ViewStyle = {
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center"
}

const LINK_WRAPPER: ViewStyle = {
  paddingVertical: spacing[1],
  marginHorizontal: spacing[4] / 2
}

const LINK_BUTTON: ViewStyle = {
  justifyContent: "center",
  backgroundColor: color.palette.gray1,
  height: 40,
  paddingHorizontal: spacing[4],
  borderRadius: 20
}

const LINK_TEXT: TextStyle = {
  fontSize: 14,
  color: color.palette.gray4
}

export interface Partner {
  linkLabel: string
  linkUrl: string
}

export interface PartnersProps {
  partners: Partner[]
  style?: StyleProp<ViewStyle>
}

export const Partners = observer((props: PartnersProps) => {
  const { partners, style } = props

  if (!partners || partners.length === 0) {
    return null
  }

  const styles = flatten([CONTAINER, style])

  const handlePress = (url: string) => {
    if (url) {
      Linking.openURL(url)
    }
  }

  return (
    <View style={styles}>
      <Text style={TITLE} text="Partners" />
      <View style={LINKS_CONTAINER}>
        {partners.map((partner, index) => (
          <View key={index} style={LINK_WRAPPER}>
            <TouchableOpacity style={LINK_BUTTON} onPress={() => handlePress(partner.linkUrl)}>
              <Text preset="bold" style={LINK_TEXT} text={partner.linkLabel} />
            </TouchableOpacity>
          </View>
        ))}
      </View>
    </View>
  )
})
